<template>
  <div>
    <v-select
      :disabled="!enabled"
      class="small-text-field "
      :required="required"
      :value="promocode"
      :items="promocodesFiltered"
      :v-model="promocode"
      item-value="id"
      :label="label"
      item-name="promocode.code"
      :height="28"
      placeholder=" "
      :hide-details="valid() == true && (error == null || error.length == 0)"
      :error-messages="valid() == true ? null : [valid()] "
      outlined
      dense
      style="width: 95px;"
      @input="updateSelf"
    >
      <template v-slot:selection="{ item, index }">
        <span
          style="font-size: 11px !important;"
          v-html="htmlForPromocode(item)"
        >{{ item.promocode.code.substring(0,7) }}</span>
      </template>
      <template v-slot:item="{ item, index }">
        <span
          style="font-size: 11px !important;"
          v-html="htmlForPromocodeExtended(item)"
        >{{ item.promocode.code }}</span>
      </template>
    </v-select>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "SelectablePromocodeInput",
  model: {
    prop: "promocode",
    event: "input"
  },
  props: {
    label: String,
    errorMessages: Object,
    required: { type: Boolean, default: true },
    promocode: Number,
    promocodes: Array,
    enabled: Boolean,
    booking: Object,
    bookingForm: Object,
    error: String
  },
  data() {
    return {
      menu: false
    };
  },
  computed: {
    promocodesFiltered: function() {
      var willBeActive = this.willBeActive;
      var booking = this.booking;
      return this.promocodes.filter(function(p) {
        return (
          (p.active &&
            p.booking_id == null &&
            p.promocode.promotion.active == true &&
            willBeActive(p)) ||
          p.id == booking.promocode
        );
      });
    }
  },
  methods: {
    valid() {
      // console.log(this.error);

      if (this.error == null) {
        return true;
      }

      return this.error;
    },
    willBeActive(p) {
      return this.bookingForm.promocodeWillBeActive(p);
    },
    htmlForPromocode(item) {
      return "<p>" + item.promocode.code + "</p>";
    },
    htmlForPromocodeExtended(item) {
      return (
        "<p><b>" +
        item.promocode.code +
        "</b><br>" +
        item.promocode.promotion.description
      );
    },
    updateSelf(rideType) {
      this.$emit("input", rideType);
    },
    focused() {
      console.log("focused");
      this.$emit("focused");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
